import React from "react";
import { ArtistProfile } from "../../data/models/Artist";
import { ArtistOnListButton } from "./ArtistOnListButton";

export const ArtistMuteButton = React.memo((props: { artistHandle: string, style?: React.CSSProperties }) => {

    const { artistHandle, style } = props
    return (<ArtistOnListButton artistHandle={artistHandle} list='muted' labels={{ loading: '...', on: 'Muted', off: 'Mute' }} style={ style } variant='secondary-invert' />)

})